import { Component, OnInit } from '@angular/core';
import { ITimeline } from './interfaces/timeline.interface';
import * as moment from 'moment';
import { SharedService } from '../../services/shared.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
})
export class TimelineComponent implements OnInit {
  BE_DATES: readonly ITimeline[] = [];

  dates: readonly ITimeline[] = [];

  indexOfClosestDate: number;

  private readonly destroySubject$ = new Subject();

  constructor(private readonly sharedService: SharedService) {}

  ngOnInit(): void {
    this.sharedService.timeline$.pipe(takeUntil(this.destroySubject$)).subscribe((data: any) => {
      if (!data) {
        this.placeholderData();
        this.dates = this.getPositionOnTimeline(this.BE_DATES);
        this.getClosestDate();
        return;
      }

      this.BE_DATES = data;
      this.dates = this.getPositionOnTimeline(this.BE_DATES);
      this.getClosestDate();
    });
  }

  getPositionOnTimeline(date: readonly ITimeline[]): readonly ITimeline[] {
    const dateArray: ITimeline[] = [];
    const YEAR_IN_NUMBER = 0.0365;
    const PERCENT_100 = 100;
    const TIME_1000 = 1000;
    const TIME_60 = 60;
    const TIME_24 = 24;

    date.forEach((element: ITimeline) => {
      const currentHoliday: Date = new Date(element.date);
      const startYear = new Date(currentHoliday.getFullYear(), 0, 0);
      const dayOfYear = Math.floor((currentHoliday.valueOf() - startYear.valueOf()) / (TIME_1000 * TIME_60 * TIME_60 * TIME_24));

      dateArray.push({
        ...element,
        position: Math.floor(dayOfYear / YEAR_IN_NUMBER / PERCENT_100),
      });
    });

    return dateArray;
  }

  getClosestDate(): void {
    const tempData = this.BE_DATES.filter((date: ITimeline) => moment(new Date(`${date.date}`)).isAfter(new Date()));

    if (tempData.length > 0) {
      this.indexOfClosestDate = this.dates.findIndex((date: ITimeline) => date.date === tempData[0].date);
    }
  }

  placeholderData(): void {
    this.BE_DATES = [
      {
        date: '2021-03-24',
        color: '#293070',
        name: 'Random ünnep stb',
      },
      {
        date: '2021-05-02',
        color: '#6C1C4F',
        name: 'Random ünnep stb stb stb stb',
      },
      {
        date: '2021-07-15',
        color: '#FDC800',
        name: 'Random',
      },
      {
        date: '2021-10-10',
        color: '#14694D',
        name: 'Random',
      },
      {
        date: '2021-10-12',
        color: '#EB7E01',
        name: 'Random',
      },
      {
        date: '2021-11-12',
        color: '#EB7E01',
        name: 'Random',
      },
    ];
  }
}
